import { createGrpcWebTransport } from '@connectrpc/connect-web';
import { tockAuthGrpcInterceptor } from './interceptors/tock-auth-grpc-interceptor';
import { unauthenticatedRedirectInterceptor } from './interceptors/unauthenticated-redirect-interceptor';
import AppSettings from 'settings/AppSettings';

/**
 * @todo - Research logging/debugging options to show JSON requests/responses
 */
export const bffTransport = createGrpcWebTransport({
  // Requests will be made to <baseUrl>/<package>.<service>/method
  baseUrl: AppSettings.BFF_BASE_URL,

  // By default, this transport uses the binary format, because
  // not all gRPC-web implementations support JSON.
  useBinaryFormat: true,

  // Interceptors apply to all calls running through this transport.
  interceptors: [
    // Attaches X-Tock-Authorization so the BFF and downstream Tock handlers
    // can perform role checks (same header AjaxActions sends for REST calls).
    tockAuthGrpcInterceptor,
    // Redirects to /logout on UNAUTHENTICATED responses, matching the
    // errorCode 1005 force-logout behavior of TockApiMiddleware.
    unauthenticatedRedirectInterceptor,
    // bffRequestLoggerInterceptor,
    // globalDiningSessionInterceptor,
  ],

  // Optional override of the fetch implementation used by the transport.
  fetch: globalThis.fetch,

  // Options for Protobuf JSON serialization.
  jsonOptions: {},
});

export const transport = bffTransport;
